import { render, staticRenderFns } from "./ProductVariant.vue?vue&type=template&id=20ad3c5a&lang=pug&"
import script from "./ProductVariant.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProductVariant.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProductVariant.vue?vue&type=style&index=0&id=20ad3c5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports